<div [ngSwitch]="status">
    <div *ngSwitchCase="enumQStatus.PendingApproval" class="status-q pending-approval">
        <img src="/assets/images/grid/status/hourglass.svg">
        <p translate>grid.status.pendingApproval</p>
    </div>
    <div *ngSwitchCase="enumQStatus.Approved" class="status-q approvaled">
        <img src="/assets/images/grid/status/check_circle.svg">
        <p translate>grid.status.approved</p>
    </div>
    <div *ngSwitchCase="enumQStatus.Rejected" class="status-q rejected">
        <img src="/assets/images/grid/status/cancel.svg">
        <p translate> grid.status.rejected</p>
    </div>
    <div *ngSwitchCase="enumQStatus.PendingPrevApproval" class="status-q pending-approval">
        <img src="/assets/images/grid/status/edit.svg">
        <p translate> grid.status.pendingPrevApproval</p>
    </div>
</div>